module.exports = __webpack_public_path__ + "static/media/singlePoint.335b9827.png";